import React, { useEffect, useState } from "react";
import { Col, DatePicker, TimePicker } from "antd";
import moment from "moment";
import { ExamTimeWay } from "service/exam";

interface DateRangePickerProps {
    examTimeWay: ExamTimeWay; //考试时间类型
    start: string; //开始时间
    end: string; //结束时间
    onChange: (value: [string, string]) => void;
    disabled: boolean; //禁止点击状态
}

export default function DateRangePickerUnify(props: DateRangePickerProps) {
    const { start, end, onChange, disabled } = props;

    const [startDate, setStartData] = useState(
        start ? moment(start) : moment()
    );
    const [startTime, setStartTime] = useState(
        end ? moment(start) : moment(moment(), "HH:mm")
    );
    const [endTime, setEndTime] = useState(
        end ? moment(end) : moment("23:59", "HH:mm")
    );

    function disabledDate(current: moment.Moment | null): boolean {
        if (!current) return false;
        return current < moment().startOf("day");
    }

    useEffect(() => {
        onChange([
            startDate.format("YYYY-MM-DD ") + startTime.format("HH:mm"),
            startDate.format("YYYY-MM-DD ") + endTime.format("HH:mm")
        ]);
    }, [startDate, startTime, endTime]);

    return (
        <>
            <Col span={5}>
                <DatePicker
                    onChange={time => setStartData(time || moment())}
                    value={moment(startDate, "YYYY-MM-DD")}
                    disabledDate={disabledDate}
                    format="YYYY-MM-DD"
                    allowClear={false}
                    style={{ width: "100%", minWidth: 0 }}
                    disabled={disabled}
                />
            </Col>

            <Col span={4} style={{ marginLeft: 10 }}>
                <TimePicker
                    value={startTime}
                    onChange={e => setStartTime(e || moment())}
                    format="HH:mm"
                    style={{ width: "100%", minWidth: 0 }}
                    allowClear={false}
                    disabled={disabled}
                />
            </Col>

            <Col span={1} style={{ textAlign: "center", width: 14 }}>
                ~
            </Col>

            {/* 未发布学生已做答或已发布状态下，考试结束时间不可以缩短 */}
            <Col span={4}>
                {disabled && (
                    <TimePicker
                        value={endTime}
                        onChange={e => setEndTime(e || moment())}
                        format="HH:mm"
                        style={{ width: "100%", minWidth: 0 }}
                        allowClear={false}
                        // disabledHours = {() => getDisabledTimes(moment(end).format("HH:mm:ss"), 0)}
                        // disabledMinutes = {() => getDisabledTimes(moment(end).format("HH:mm:ss"), 1)}
                    />
                )}

                {!disabled && (
                    <TimePicker
                        value={endTime}
                        onChange={e => setEndTime(e || moment())}
                        format="HH:mm"
                        style={{ width: "100%", minWidth: 0 }}
                        allowClear={false}
                    />
                )}
            </Col>
        </>
    );
}
